export const WebsocketSurveyEvents = {
  completed: "Survey\\SurveyCompletedEvent",
};

export const WebsocketUserEvents = {
  dataUpdate: "User\\UserUpdates",
  messageUpdate: "User\\UserMessageUpdates",
  proofToApprove: "User\\UserProofToApprove",
};

export const WebsocketEvents = {
  survey: WebsocketSurveyEvents,
  user: WebsocketUserEvents,
};

export const WebsocketStepEvents = {
  stepUpdated: "Challenge\\Achievement\\AchievementUpdatedEvent",
  moduleUpdated: "Challenge\\ChallengeUpdateEvent",
};

export const parseSurveySubmissionChannel = (surveySubmissionId) =>
  `user_achievement.survey_completed.${surveySubmissionId}`;

export const parseUserUpdateChannel = (userId) => `user.updates.${userId}`;

export const parseStepUpdateChannel = (challengeId) =>
  `achievement.update.${challengeId}`;

export const parseModuleDetailsUserUpdateChannel = (challengeId, userId) =>
  `challenge.update.${challengeId}.${userId}`;
